import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CartReview, { CartReviewProduct } from "../../../CartReview";
import { TransactionDetails } from "../../types";
import CardText from "../CardText";
import TransactionCard from "../TransactionCard";

type Props = {
  cart: TransactionDetails["cart"];
  onItemPress: (item: CartReviewProduct) => void;
};

export default function ItemsCard({ cart, onItemPress }: Props) {
  const tailwind = useTailwind();

  if (!cart.items.length) {
    return null;
  }

  return (
    <TransactionCard>
      <CardText.Title text="Productos" />
      <View style={tailwind("gap-4 mt-4")}>
        {cart.items.map((product, index) => (
          <CartReview.Item
            key={index}
            product={product}
            handleCartItemSelect={() => onItemPress(product)}
          />
        ))}
      </View>
      {cart.comments && cart.comments != "" && (
        <View style={tailwind("mt-4 gap-2")}>
          <CardText.Subtitle text="Comentarios" />
          <CardText.Body text={cart.comments} />
        </View>
      )}
    </TransactionCard>
  );
}
